export default __webpack_public_path__ + "app/styles/fonts/shared-folder/groups.woff";